import { APP_INITIALIZER, ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginComponent } from './login/login.component';
import { ReactiveFormsModule } from '@angular/forms';
import { FormsModule } from '@angular/forms';
import { ToastrModule } from 'ngx-toastr';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RefreshComponent } from './refresh/refresh.component';
import { MatRadioModule } from '@angular/material/radio';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { AppInterceptorService } from './app-interceptor.service';
import { Router } from '@angular/router';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatetimepickerModule } from '@mat-datetimepicker/core';
import { MatNativeDatetimeModule } from '@mat-datetimepicker/core';
import { TraceService, createErrorHandler } from '@sentry/angular-ivy';
import { ResetPasswordNewComponent } from './reset-password-new/reset-password-new.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { FontAwesomeModule, FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatDividerModule } from '@angular/material/divider';
import { MatButtonModule } from '@angular/material/button';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSelectModule } from '@angular/material/select';
import { MatTableModule } from '@angular/material/table';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { DataTablesModule } from 'angular-datatables';
import { NgToggleModule } from 'ng-toggle-button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { NavbarComponent } from './navbar/navbar.component';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatChipsModule } from '@angular/material/chips';
import { faStackOverflow, faGithub, faMedium } from '@fortawesome/free-brands-svg-icons';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { NgbModule, NgbDatepickerModule, NgbTimepickerModule, NgbDateNativeAdapter, NgbDateAdapter, NgbDateParserFormatter, NgbModalModule } from '@ng-bootstrap/ng-bootstrap';
import {
	faSync,
	faMale,
	faFemale,
	faSquare,
	faCheckSquare,
	faMedkit,
	faAmbulance,
	faBrain,
	faShip,
	faHome,
	faPowerOff,
	faLock,
	faCloudDownloadAlt,
	faSpinner,
	faTh,
	faAngleDown,
	faAngleUp,
	faTimes,
	faUser,
	faUsers,
	faEnvelope,
	faBookMedical,
	faFileMedical,
	faFileMedicalAlt,
	faPumpMedical,
	faNotesMedical,
	faClinicMedical,
	faLaptopMedical,
	faCommentMedical,
	faBriefcaseMedical,
	faHandHoldingMedical,
	faCheck,
	faMinus,
	faCalendar,
	faCalendarAlt,
	faCalendarWeek,
	faFilter,
	faPlus,
	faPencilAlt,
	faTrash,
	faKey,
	faUserAlt,
	faUserPlus,
	faUserCircle,
	faCapsules,
	faTablet,
	faTablets,
	faTabletAlt,
	faSave,
	faSignOutAlt,
	faHelicopter,
	faBuilding,
	faFlag,
	faDatabase,
	faCity,
	faEye,
	faEyeSlash,
	faStar,
	faRupeeSign,
	faFileDownload,
	faDollarSign,
	faWeightHanging,
	faBalanceScale,
	faQuestionCircle,
	faCog,
	faCogs,
	faEdit,
	faListAlt,
	faFile
} from '@fortawesome/free-solid-svg-icons';
import { BreadcrumbComponent } from './breadcrumb/breadcrumb.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { AngularSignaturePadModule } from '@almothafar/angular-signature-pad';
import { NgxFileDropModule } from 'ngx-file-drop';
import { QuillModule } from 'ngx-quill';
import { MatMenuModule } from '@angular/material/menu';
import { PhoneInputComponent } from './shared/phone-input/phone-input.component';
import { CustomInputComponent } from './shared/custom-input/custom-input.component';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { AppointmentListComponent } from './appointment/appointment-list/appointment-list.component';
import { AppointmentCreateComponent } from './appointment/appointment-create/appointment-create.component';
import { CompanyListComponent } from './masters/company/company-list/company-list.component';
import { VesselListComponent } from './masters/vessel/vessel-list/vessel-list.component';
import { ProfileListComponent } from './masters/profile/profile-list/profile-list.component';
import { ProfileCreateComponent } from './masters/profile/profile-create/profile-create.component';
import { BranchListComponent } from './masters/company/branch-list/branch-list.component';
import { BranchCreateComponent } from './masters/company/branch-create/branch-create.component';
import { RankListComponent } from './masters/rank/rank-list/rank-list.component';
import { InvoiceListComponent } from './appointment/invoice-list/invoice-list.component';
import { InvoiceCreateComponent } from './appointment/invoice-create/invoice-create.component';
import { ScaleCreateComponent } from './masters/scale/scale-create/scale-create.component';
import { ScaleListComponent } from './masters/scale/scale-list/scale-list.component';
import { CategoryCreateComponent } from './masters/category/category-create/category-create.component';
import { CategoryListComponent } from './masters/category/category-list/category-list.component';
import { QuestionFormComponent } from './masters/questionbank/question-form/question-form.component';
import { QuestionCreateComponent } from './masters/questionbank/question-create/question-create.component';
import { QuestionListComponent } from './masters/questionbank/question-list/question-list.component';
import { QuestionTranslationComponent } from './masters/questionbank/question-translation/question-translation.component';
import { UserAnsComponent } from './appointment/user-ans/user-ans.component';
import { GenderIconComponent } from './shared/gender-icon/gender-icon.component';
import { UserScoreComponent } from './appointment/user-score/user-score.component';
import { ReportComponent } from './appointment/report/report.component';

@NgModule({
	declarations: [
		AppComponent,
		LoginComponent,
		RefreshComponent,
		ResetPasswordNewComponent,
		DashboardComponent,
		NavbarComponent,
		BreadcrumbComponent,
		PhoneInputComponent,
		CustomInputComponent,
		AppointmentListComponent,
		AppointmentCreateComponent,
		CompanyListComponent,
		VesselListComponent,
		ProfileListComponent,
		ProfileCreateComponent,
		BranchListComponent,
		BranchCreateComponent,
		RankListComponent,
		InvoiceListComponent,
		InvoiceCreateComponent,
		ScaleCreateComponent,
		ScaleListComponent,
		CategoryCreateComponent,
		CategoryListComponent,
		QuestionFormComponent,
		QuestionCreateComponent,
		QuestionListComponent,
		QuestionTranslationComponent,
		UserAnsComponent,
		GenderIconComponent,
		UserScoreComponent,
		ReportComponent,
	],
	imports: [
		BrowserModule,
		MatProgressBarModule,
		AppRoutingModule,
		ReactiveFormsModule,
		FormsModule,
		HttpClientModule,
		ToastrModule.forRoot(),
		BrowserAnimationsModule,
		MatRadioModule,
		MatAutocompleteModule,
		NgbModule,
		MatDatepickerModule,
		MatDatetimepickerModule,
		MatNativeDateModule,
		MatNativeDatetimeModule,
		FontAwesomeModule,
		MatTooltipModule,
		MatExpansionModule,
		MatFormFieldModule,
		MatInputModule,
		MatCardModule,
		MatIconModule,
		MatDividerModule,
		MatButtonModule,
		MatSlideToggleModule,
		MatSelectModule,
		MatTableModule,
		MatProgressSpinnerModule,
		DataTablesModule,
		NgToggleModule,
		MatButtonToggleModule,
		MatToolbarModule,
		NgSelectModule,
		MatCheckboxModule,
		AngularSignaturePadModule,
		NgxFileDropModule,
		QuillModule.forRoot(),
		MatMenuModule,
		NgxChartsModule,
		MatGridListModule,
		NgbDatepickerModule,
		FormsModule,
		MatChipsModule
	],
	providers: [
		{
			provide: ErrorHandler,
			useValue: createErrorHandler({
				showDialog: false,
			}),
		},
		{
			provide: TraceService,
			deps: [Router],
		},
		{
			provide: APP_INITIALIZER,
			useFactory: () => () => { },
			deps: [TraceService],
			multi: true,
		},
		{
			provide: HTTP_INTERCEPTORS,
			useClass: AppInterceptorService,
			multi: true
		},
		MatNativeDatetimeModule
	],
	bootstrap: [AppComponent]
})
export class AppModule {
	constructor(library: FaIconLibrary) {
		library.addIcons(
			faUserPlus,
			faUserCircle,
			faSync,
			faMale,
			faFemale,
			faStackOverflow,
			faGithub,
			faMedium,
			faSquare,
			faCheckSquare,
			faMedkit,
			faAmbulance,
			faBrain,
			faShip,
			faHome,
			faPowerOff,
			faLock,
			faCloudDownloadAlt,
			faSpinner,
			faTh,
			faAngleDown,
			faAngleUp,
			faTimes,
			faUser,
			faUsers,
			faUserAlt,
			faEnvelope,
			faBookMedical,
			faFileMedical,
			faMedkit,
			faFileMedicalAlt,
			faPumpMedical,
			faNotesMedical,
			faClinicMedical,
			faLaptopMedical,
			faCommentMedical,
			faBriefcaseMedical,
			faHandHoldingMedical,
			faCheck,
			faMinus,
			faCalendar,
			faCalendarAlt,
			faCalendarWeek,
			faFilter,
			faPlus,
			faPencilAlt,
			faTrash,
			faLock,
			faKey,
			faCapsules,
			faTablet,
			faTablets,
			faTabletAlt,
			faSave,
			faSignOutAlt,
			faHelicopter,
			faBuilding,
			faFlag,
			faDatabase,
			faCity,
			faEye,
			faEyeSlash,
			faStar,
			faCalendar,
			faRupeeSign,
			faFileDownload,
			faCloudDownloadAlt,
			faDollarSign,
			faWeightHanging,
			faBalanceScale,
			faQuestionCircle,
			faCog,
			faCogs,
			faEdit,
			faListAlt,
			faFile
		);
	}
}
